import clearBlocksHtml from './clear-blocks-html';
import clearPageTemplatesHtml from './clear-page-templates-html';
import clearGlobalsHtml from './clear-globals-html';
import normalizeLocalizedSource from './normalize-localized-source';
import trimLocaleFromSource from './trim-locale-from-source';

export default {
  clearBlocksHtml,
  clearPageTemplatesHtml,
  clearGlobalsHtml,
  normalizeLocalizedSource,
  trimLocaleFromSource,
};
